import React, { useMemo } from 'react';
import { observer } from 'mobx-react';

import { arrGetCompanyApplicationMapping } from '../../models/company/CompanyApplicationMapping';
import AccordionLayout from './Accordion/AccordionLayout';
import { useStore } from '../hooks';

type Props = {
    selectedApplication: arrGetCompanyApplicationMapping[];
};

function ExpansionApplication(props: Props) {
    const { selectedApplication } = props;

    const { userCompanyStore } = useStore();
    const { currentUserCompanyMapping } = userCompanyStore;

    const applicationGroups = useMemo(() => {
        const systemTypeOrder = {
            PRD: 1,
            'PRE-PRD': 2,
            UAT: 3
        };

        return selectedApplication.slice(0).sort((a, b) => {
            const aOrder = systemTypeOrder[a.system_type || 'PRD'];
            const bOrder = systemTypeOrder[b.system_type || 'PRD'];

            return aOrder - bOrder;
        });
    }, [selectedApplication]);

    return (
        <div>
            {applicationGroups.map((dataObj, index) => {
                const foundUserCompany = currentUserCompanyMapping.find(
                    userCompany =>
                        userCompany.sid === dataObj.company_id &&
                        userCompany.platform_id === dataObj.platform_id &&
                        userCompany.system_type === dataObj.system_type
                );

                const collapsed = !!foundUserCompany?.is_collapse;
                const systemType = foundUserCompany?.system_type;

                return (
                    <AccordionLayout
                        key={index}
                        header={dataObj.platform_name}
                        contentData={dataObj.application_list}
                        initialExpanded={!collapsed}
                        systemType={systemType}
                    />
                );
            })}
        </div>
    );
}

export default observer(ExpansionApplication);
